import { TextLargeParagraph } from '@carboncopyco/ui';
import { getTimezoneName } from '@carboncopyco/utils';
import { useState } from 'react';
import type { CsvParams } from '../../../Dashboard/SessionBreakdownComponents/types';
import { DownloadCsvButton } from '../../DownloadCsv';
import { TitleCard } from '../../InfoPageCards/TitleCard';
import { usePlaybookPageProps } from '../PlaybookPageContext';
import { PlaysSessionsBreakdownTable } from './PlaysSessionBreakdownTable';

export const PlaysSessionsBreakdownCard = () => {
  const { organizationId, playbookId, workspaceId } = usePlaybookPageProps();
  const [csvParams, setCsvParams] = useState<CsvParams>({
    params: {
      organizationId,
      resourceTypes: ['play'],
      timezone: getTimezoneName(),
      playbookId,
    },
    isDisabled: false,
  });

  return (
    <TitleCard
      radius
      border="ds-regular"
      header={
        <div className="h-ds-15 flex px-6 items-center justify-between">
          <TextLargeParagraph
            label="Session breakdown"
            color="text-ds-natural-600"
          />
          <div className="flex gap-4">
            <DownloadCsvButton
              params={csvParams.params}
              disabled={csvParams.isDisabled}
              location="playbook_info_page"
            />
          </div>
        </div>
      }
    >
      <PlaysSessionsBreakdownTable
        playbookId={playbookId}
        workspaceId={workspaceId}
        organizationId={organizationId}
        setCsvParams={setCsvParams}
      />
    </TitleCard>
  );
};
